$(function () {
    var c = window.patientInformation.constants;

    $('#deleteAccountConfirmModal .delete-user').click(function () {
        createSubDomainCookie(c.notificationCookieName, 'deleteaccount');
        window.location = $(this).data("url");
    });
    
});